import React, {useEffect, useState} from 'react';
import ReactDOM from 'react-dom/client';
import '@sendbird/uikit-react/dist/index.css';
import axios from 'axios';
import NewGroup from "./NewGroup";
import NewChat from "./NewChat";
import ConversationChat from "./ConversationChat";
import SendBirdCall from "sendbird-calls";
import '@sendbird/uikit-react/dist/index.css';
import '../override.css';

const GeneralChat = ({appId, authUser, accessToken, disableCall, authRole, avatar, authId}) => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [newChatModel, setNewChatModel] = useState(false);
    const [newGroupModel, setNewGroupModel] = useState(false);
    const [conversations, setConversations] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [openConversation, setOpenConversation] = useState(null);
    const [conversationStyle, setConversationStyle] = useState(0);
    const [messageText, setMessageText] = useState('');
    const [conversationId, setConversationId] = useState(null);
    const [allUsers, setUsers] = useState(null);
    const [agents, setAgents] = useState(null);
    const [sendBirdUser, setSendBirdUSer] = useState(null);
    const [onlineUsers, setOnlineUsers] = useState([]);

    const drawerClick = () => {
        setDrawerOpen(prev => !prev);
    };

    useEffect(() => {
        const handleOpenUserChat = async (e) => {

            const { authId, authRole ,userId } = e.detail;

            if(authId){
                try {
                    let url = `/${role}/get-conversation/${authId}?role=${authRole}`;
                    if (userId) {
                        url += `&userId=${userId}`;
                    }

                    const response = await fetch(url, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    });

                    if (!response.ok) {
                        throw new Error(`Failed to fetch conversation for authId ${authId}`);
                    }

                    const conversation = await response.json();

                    if (conversation?.id) {
                        setDrawerOpen(true);
                        openDrawer(conversation.id);
                    } else {
                        console.warn("No conversation returned for this user.");
                    }
                } catch (error) {
                    console.error("Error fetching conversation:", error);
                }
            }else{
                console.log(e);
            }
        };

        window.addEventListener("open-user-chat", handleOpenUserChat);

        return () => {
            window.removeEventListener("open-user-chat", handleOpenUserChat);
        };
    }, []);

    const handleSend = () => {
        if (messageText.trim() === '') return;

        const url = `/${role}/general-chat/${openConversation?.data?.selectedConversation.id}/send-message`;

        axios.post(url, {
            message: messageText
        })
            .then(() => {
                setMessageText('');
                openDrawer(conversationId);
            })
            .catch(error => {
                console.error('Error:', error);
            });
    };

    const getConversations = async () => {
        const response = await fetch(`/${role}/get-conversations`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setConversations(data);
    };

    const getSendbirdUser = async () => {
        const response = await fetch(`/get-admin/${authId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setSendBirdUSer(data);
    };

    // useEffect(() => {
    //     if (authId) {
    //         getSendbirdUser();
    //     }
    // }, [authId]);

    const getAllUsers = async () => {
        const response = await fetch(`/${role}/get-all-users`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setUsers(data);
    };

    const getUsers = async () => {
        const response = await fetch(`/${role}/get-agents`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setAgents(data);
    };

    function updateStatusIndicators(userIds) {
        userIds.forEach(userId => {
            document.querySelectorAll(`.status-indicator[data-status-id="${userId}"]`).forEach(element => {
                element.classList.add('bg-success');
                element.classList.remove('bg-danger');
            });
        });
    }

    function updateStatusIndicator(userId, isOnline) {
        document.querySelectorAll(`.status-indicator[data-status-id="${userId}"]`).forEach(element => {
            if (isOnline) {
                element.classList.add('bg-success');
                element.classList.remove('bg-danger');
            } else {
                element.classList.remove('bg-success');
                element.classList.add('bg-danger');
            }
        });
    }

    let openedConversations = [];

    let admin = authRole === 'agency_admin' ? 1 : 0;
    let role = `${admin ? 'admin' : 'agent'}`;

    const openDrawer = (conversationId) => {
        setConversationId(conversationId);
        // if (!openedConversations.includes(conversationId)) {
            openedConversations.push(conversationId);

            if (window.innerWidth <= 1024) {
                setConversationStyle(0);
            } else {
                setConversationStyle(21);
                // setConversationStyle(openedConversations.length * 21);
            }
            if (conversationId) {
                let url = `/${role}/general-chat/${conversationId}/selected-conversation`;

                axios.post(url, {
                    online_users: onlineUsers
                })
                    .then(response => setOpenConversation(response)
                    )
                    .catch(error => {
                        console.error('Error:', error);
                    });
            // }
        }
    }

    function closeChat(conversationId) {
        openedConversations = openedConversations.filter(id => id !== conversationId);
        var chatDrawer = document.getElementById('chatDrawer-' + conversationId);
        if (chatDrawer) {
            chatDrawer.remove();
        }
        var drawers = document.getElementsByClassName('chatDrawer');
        for (var i = 0; i < drawers.length; i++) {
            drawers[i].style.right = ((i + 1) * 21) + '%';
        }
    }

    useEffect(() => {
        getConversations();
        getAllUsers();
        getUsers();
    }, [])

    const openNewChatModel = () => {
        setNewChatModel(true);
    }
    const openNewGroupModel = () => {
        setNewGroupModel(true);
    }

    // useEffect(() => {
    //     if (appId && sendBirdUser && sendBirdUser?.access_token) {
    //         if (!SendBirdCall.isInitialized) {
    //             SendBirdCall.setLoggerLevel(SendBirdCall.LoggerLevel.INFO);
    //             SendBirdCall.init(appId);
    //             console.log("SendBirdCall Initialized");
    //         }
    //
    //         SendBirdCall.authenticate({userId: authId, accessToken: sendBirdUser.access_token})
    //             .then(() => {
    //                 SendBirdCall.connectWebSocket().then(() => {
    //                     console.log('connect websocket')
    //                 })
    //             })
    //
    //         initializeSendBirdCall();
    //     }

    // }, [sendBirdUser]);

    const initializeSendBirdCall = () => {
        SendBirdCall.addListener(sendBirdUser.user_id, {
            onRinging: (call) => {
                function formatTime(seconds) {
                    let minutes = Math.floor(seconds / 60);
                    let secs = seconds % 60;
                    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
                }

                const accept = () => {
                    acceptCall(call);

                    document.querySelector(".accept-call").style.display = "none";
                    document.querySelector(".call-timer").style.display = "inline-block";
                    document.querySelector(".end-call").style.display = "inline-block";
                    document.querySelector(".mute-call").style.display = "inline-block";

                    call.onEstablished = () => {
                        console.log("Call established!");
                        callStartTime = Date.now();

                        let timerElement = document.querySelector(".call-timer");
                        timerElement.className = "call-timer";
                        timerElement.style.marginLeft = "10px";
                        timerElement.style.fontWeight = "bold";
                        timerElement.innerText = "00:00";
                        if (!timerElement) {
                            console.error("Call timer element not found!");
                            return;
                        }

                        timerInterval = setInterval(() => {
                            let elapsedTime = Math.floor((Date.now() - callStartTime) / 1000);
                            timerElement.innerText = formatTime(elapsedTime);
                        }, 1000);
                    };
                };

                const reject = () => {
                    console.log("Call ended");
                    call.end();
                    const notificationContainer = document.getElementById("noty_layout__center");
                    notificationContainer.style.display = 'none';

                    clearInterval(timerInterval);
                    closeAllNotifications();
                    const muteCallButton = document.querySelector(".mute-call");
                    if (muteCallButton) {
                        muteCallButton.style.display = "none";
                    }
                }

                const startVideoCall = () => {
                    const videoIcon = document.querySelector(".fa-video");
                    const stopVideoIcon = document.querySelector(".fa-video-slash");

                    if (call.isLocalVideoEnabled) {
                        call.stopVideo();
                        videoIcon.style.display = "none";
                        stopVideoIcon.style.display = "inline-block";
                    } else {
                        call.startVideo();
                        videoIcon.style.display = "inline-block";
                        stopVideoIcon.style.display = "none";
                    }
                };

                const mute = () => {
                    const micIcon = document.querySelector(".fa-microphone");
                    const micSlashIcon = document.querySelector(".fa-microphone-slash");
                    if (call.isLocalAudioEnabled) {
                        call.muteMicrophone();
                        micIcon.style.display = "none";
                        micSlashIcon.style.display = "inline-block";
                    } else {
                        call.unmuteMicrophone();
                        micIcon.style.display = "inline-block";
                        micSlashIcon.style.display = "none";
                    }
                }

                let callStartTime = null;
                let timerInterval;
                const videoButton = call.isVideoCall === true ? `<button class="btn start-call video-call">
                                    <i class="fas fa-video"></i><i class="fas fa-video-slash" style="display:none;"></i>
                                 </button>` : ``;

                const text = `
                <div style="padding:10px">
                    <div style="text-align: center; padding-bottom: 35px; padding-top: 40px">
                        <img src='${call.caller.profileUrl}' width="60" height="60" class="rounded-circle" alt="star-rating-svg-logo">
                      <br/>
                        <div class="" style="font-weight: bold; font-size: large; margin-top: 10px">
                            ${call.caller.nickname}
                        </div>
                        <div style="color: #cbcbcb; font-size: small"> is calling you</div>
                        <div class="call-timer" style="display:none">00:00</div>
                    </div>
                </div>
                <div class="transbox">
                    <div class="d-flex justify-content-between">
                         <button class="btn btn-accept accept-call">
                            <i class="fas fa-phone-alt" style="margin-right: 5px" ></i>
                         </button>
                         <button class="btn btn-accept mute-call">
                            <i class="fas fa-microphone"></i><i class="fas fa-microphone-slash" style="display:none"></i>
                         </button>
                         ${videoButton}
                         <button class="btn btn-danger end-call">
                            <i class="fas fa-phone-slash" style="margin-right: 5px"></i>
                         </button>
                    </div>
                </div>`;

                const isVideoCall = call.isVideoCall;

                createCustomNotification({message: text, isVideoCall});

                setTimeout(() => {
                    document.querySelector(".accept-call")?.addEventListener("click", accept);
                    document.querySelector(".mute-call")?.addEventListener("click", mute);
                    document.querySelector(".end-call")?.addEventListener("click", reject);
                    document.querySelector(".start-call")?.addEventListener("click", startVideoCall);

                }, 200);

                call.onEnded = () => {
                    closeAllNotifications();
                    clearInterval(timerInterval);
                    const notificationBody = document.querySelector(".noty_layout__center");

                    if (notificationBody) {
                        notificationBody.style.display = "none";
                    }
                };
            },
        });
    };

    const acceptCall = (call) => {
        console.log("Call accepted", call);
        try {
            call.accept({
                callOption: {
                    localMediaView: document.getElementById('local_video_element_id'),
                    remoteMediaView: document.getElementById('remote_video_element_id'),
                    audioEnabled: true,
                    videoEnabled: true
                },
            });

        } catch (error) {
            closeAllNotifications();
            const notificationBody = document.querySelector(".noty_layout__center");

            if (notificationBody) {
                notificationBody.style.display = "none";
            }
        }
    };

    function closeAllNotifications() {
        if (activeNotifications.length === 0) {
            console.warn("No active notifications to close.");
            return;
        }
        activeNotifications.forEach((notification) => {
            if (notification.parentNode) {
                notification.parentNode.removeChild(notification);
            }
        });
        const notificationContainer = document.getElementById("noty_layout__center");
        notificationContainer.style.display = 'none';

        activeNotifications = [];
        initializeSendBirdCall();
    }

    let activeNotifications = [];

    Echo.private('chat.conversation.' + authId)
        .listen('.new-chat-notification', (e) => {
            setDrawerOpen(true);
            openDrawer(e.message.conversation_id);
        });

    Echo.join('chat-online')
        .here((users) => {
            const usersIds = users.map(user => {
                return user.role === 'customer' ? +user.selected_customer_id : +user.id;
            });
            setOnlineUsers(usersIds);
            console.log('onlineUsers', usersIds);
        })
        .joining((user) => {
            setOnlineUsers((oldArray) => [...oldArray, user.id]);
        })
        .leaving((user) => {
            const usersIds = onlineUsers.filter((id) => id !== user.id);
            setOnlineUsers(usersIds);
        });

    function createCustomNotification({message, duration, isVideoCall}) {

        const notificationContainer = document.getElementById("noty_layout__center");
        const remoteVideoElement = document.getElementById("remote_video_element_id");
        notificationContainer.style.display = 'block';

        const notificationBody = notificationContainer.querySelector(".noty_body");
        const notification = document.createElement("div");

        const messageSpan = document.createElement("div");
        messageSpan.innerHTML = message;

        const closeButton = document.createElement("button");
        closeButton.innerHTML = "&times;";
        closeButton.classList.add("position-absolute", "top-0", "right-0", "mt-4", "mr-2", "btn-close", "text-white");

        if (isVideoCall === true) {
            remoteVideoElement.style.height = "500px";
            remoteVideoElement.style.width = "800px";
            notificationContainer.style.height = "50rem";
            notificationContainer.style.width = "50rem";
        } else {
            remoteVideoElement.style.height = "0px";
            remoteVideoElement.style.width = "0px";
            notificationContainer.style.height = "20rem";
            notificationContainer.style.width = "20rem";
        }

        closeButton.onclick = () => {
            notification.remove();
            notificationContainer.style.display = 'none';
            activeNotifications = activeNotifications.filter((n) => n !== notification);
        };
        notification.appendChild(messageSpan);
        notification.appendChild(closeButton);
        notificationBody.appendChild(notification);
        activeNotifications.push(notification);

        if (duration) {
            setTimeout(() => {
                if (notification.parentNode) {
                    notification.parentNode.removeChild(notification);
                }
                activeNotifications = activeNotifications.filter((n) => n !== notification);
            }, duration);
        }
    }

    const filteredConversations = conversations?.filter((conversation) =>
        conversation?.group_name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div>
            <div id="noty_layout__center" className="noty_layout" style={{display: "none"}}>
                <div className="d-flex justify-content-between">Call</div>
                <div className="noty_body custom-notification">
                    <video id="remote_video_element_id" autoPlay/>
                    <video id="local_video_element_id" autoPlay/>
                </div>
            </div>


            <div id="drawer-container" className="sendbirdDrawerContainer">
                <a onClick={drawerClick}>
                    {drawerOpen ?
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd"
                                  d="M7.0573 12.9403L8.94291 11.0547L16.0001 18.1119L23.0573 11.0547L24.9429 12.9403L16.0001 21.8831L7.0573 12.9403Z"
                                  fill="white"></path>
                        </svg>
                        :
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.7832 15.2022V12.45C9.7832 11.8977 9.33549 11.45 8.7832 11.45C8.23092 11.45 7.7832 11.8977 7.7832 12.45V15.2022C7.7832 15.7545 8.23092 16.2022 8.7832 16.2022C9.33549 16.2022 9.7832 15.7545 9.7832 15.2022Z"
                                fill="#ffff"></path>
                            <path
                                d="M16.2666 15.2022V12.45C16.2666 11.8977 15.8189 11.45 15.2666 11.45C14.7143 11.45 14.2666 11.8977 14.2666 12.45V15.2022C14.2666 15.7545 14.7143 16.2022 15.2666 16.2022C15.8189 16.2022 16.2666 15.7545 16.2666 15.2022Z"
                                fill="#ffff"></path>
                            <path fillRule="evenodd" clipRule="evenodd"
                                  d="M12.0008 0.973633C10.6172 0.973633 9.49558 2.09527 9.49558 3.47888C9.49558 4.50705 10.115 5.39055 11.0009 5.77664L11 7.5H3.25V19C3.25 20.3807 4.36929 21.5 5.75 21.5H18.25C19.6307 21.5 20.75 20.3807 20.75 19V10C20.75 8.61929 19.6307 7.5 18.25 7.5H13L13.0009 5.77653C13.8868 5.3904 14.5061 4.50696 14.5061 3.47888C14.5061 2.09527 13.3844 0.973633 12.0008 0.973633ZM5.25 9.5V19C5.25 19.2761 5.47386 19.5 5.75 19.5H18.25C18.5261 19.5 18.75 19.2761 18.75 19V10C18.75 9.72386 18.5261 9.5 18.25 9.5H5.25Z"
                                  fill="#ffff"></path>
                            <path d="M0.250977 16.5788V10.5789H2.25098L2.25098 16.5788H0.250977Z"
                                  fill="#ffff"></path>
                            <path d="M21.7511 10.5789V16.5788H23.7511V10.5789H21.7511Z" fill="#ffff"></path>
                        </svg>
                    }
                </a>
                {drawerOpen &&
                <div id="drawer" className="sendbirdDrawer">
                    <div className="d-flex align-items-center justify-content-center mt-2 ">
                        <div>
                            <button className="btn btn-sm rounded-lg" type="button" data-toggle="modal"
                                    data-target="#chatModal" id="btnNewChat" onClick={openNewChatModel}>
                                <i className="fas fa-user add-chat-icon"/>
                                New Chat
                            </button>

                            <button className="btn btn-sm rounded-lg" data-toggle="modal" data-target="#groupModal"
                                    type="button" onClick={openNewGroupModel}
                                    id="btnAddGroup">
                                <i className="fas fa-users add-chat-icon"/>
                                Add Group
                            </button>
                        </div>
                    </div>

                    <div className="px-2 pt-2 pb-1">
                        <input
                            type="text"
                            id="searchInput"
                            className="form-control"
                            placeholder="Search"
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />

                    </div>
                    <div className="list-group conversation-list border-0" id="conversationList">
                        {conversations.map((conversation) => {
                            const isGroup = conversation.is_group;
                            const isAuthor = conversation.author_id == authId;
                            const isCustomerOrUser = conversation.is_customer === 1 ? conversation.customer_user.user : conversation.to_user;
                            // const isCustomerOrUser = conversation.is_customer == 1 ? conversation.customer : conversation.to_user;
                            const isToCustomerOrUser = conversation.is_customer === 1 ? conversation.customer_user.user : conversation.user;
                            const isShowUser = conversation.is_customer === 1 && conversation.customer_user?.customer?.name;
                            const isOnline = isAuthor ? conversation?.user_id : conversation?.auth_id;

                            const user = isGroup
                                ? null
                                : isAuthor
                                    ? isCustomerOrUser
                                    : isToCustomerOrUser;

                            const avatarSrc = isGroup
                                ? '/images/group.jpg'
                                : user?.avatar_image || '/images/default-avatar.png';

                            const userName = isGroup ? conversation.group_name : user?.name || '';
                            const unreadCount = conversation.my_unread_count?.unread_message_count || 0;
                            const lastMessage = conversation.last_message?.message || '';
                            const lastMessageTime = conversation.last_message?.created_at
                                ? moment(conversation.last_message.created_at).fromNow()
                                : '';

                            return (
                                <li
                                    key={conversation?.id}
                                    className="media mt-0 px-3 py-2 cursor-pointer border-top border-bottom conversation-item"
                                    data-group-name={conversation.group_name || ''}
                                    data-conversation-id={conversation.id}
                                    data-user-name={userName}
                                    onClick={() => openDrawer(conversation.id)}
                                >
                                    <div className="mr-2">
                                        <a
                                            href="#"
                                            className={isGroup ? 'conversation-img' : 'status-indicator-container conversation-img'}
                                            id={isGroup ? 'avatarImage' : undefined}
                                        >
                                            <img src={avatarSrc} className="rounded-circle" alt=""/>
                                            {!isGroup && (
                                                <span
                                                      className={
                                                          onlineUsers.includes(isOnline)
                                                              ? "status-indicator bg-success"
                                                              : "status-indicator bg-danger"
                                                      }/>
                                            )}
                                        </a>
                                    </div>

                                    <div className="media-body">
                                        <div
                                            className="media-title font-weight-semibold d-flex justify-content-between">
                                            {userName} {isShowUser ? `(${isShowUser})` : ''}
                                            {unreadCount > 0 && (
                                                <span className="badge badge-pill badge-light conversation-badge">
                                                  {unreadCount}
                                                </span>
                                            )}
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            {lastMessage && (
                                                <>
                                                      <span
                                                          className="font-size-sm text-muted"
                                                          dangerouslySetInnerHTML={{__html: lastMessage}}
                                                      />
                                                    <span className="font-size-sm text-muted">{lastMessageTime}</span>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </li>
                            );
                        })}
                        <li id="noResultsMessage"
                            className="media d-none justify-content-center">No User Found
                        </li>
                    </div>
                </div>
                }
            </div>

            {newChatModel &&
                <div id="chatModal" className="modal fade" tabIndex="-1" role="dialog" aria-labelledby="modalTitle">
                    <NewChat allUsers={allUsers} authRole={authRole} getConversations={getConversations} />
                </div>
            }

            {newGroupModel &&
            <div id="groupModal" className="modal fade" tabIndex="-1" role="dialog" aria-labelledby="modalTitle">
                <NewGroup agents={agents} authRole={authRole} setNewGroupModel={setNewGroupModel}
                          getConversations={getConversations}/>
            </div>
            }

            {openConversation &&
            (<div className="chatDrawer" id={"chatDrawer-" + openConversation} style={{right: conversationStyle + "%"}}>
                    <ConversationChat openConversation={openConversation} authId={authId} authAvatar={avatar}
                                      handleSend={handleSend}
                                      setMessageText={setMessageText}
                                      setOpenConversation={setOpenConversation}
                                      messageText={messageText}
                                      role={role}
                                      createCustomNotification={createCustomNotification}
                                      closeAllNotifications={closeAllNotifications}
                                      onlineUsers={onlineUsers}
                                      disableCall={disableCall}/>
                </div>
            )}
        </div>
    );
}


const rootElement = document.getElementById('general-chat-app');
const appId = rootElement.dataset.appId;
const user = rootElement.dataset.user;
const accessToken = rootElement.dataset.accessToken;
const avatar = rootElement.dataset.avatar;
const authId = rootElement.dataset.authId;
const authRole = rootElement.dataset.authRole;
const disableCall = rootElement.dataset.disableCall;

const root = ReactDOM.createRoot(rootElement);

root.render(
    <GeneralChat appId={appId} disableCall={disableCall} authUser={user} accessToken={accessToken} authRole={authRole}
                 avatar={avatar} authId={authId}/>
);
